import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { IoMdShare } from "react-icons/io";
import { FaEye } from "react-icons/fa";
import VideoPlayer from "../../utils/videoPlayer2";

export default function Detail() {
    const [data, setData] = useState<any>(null);
    const navigate = useNavigate();

    const getData = async () => {
        const name = window.location.pathname.split("/").pop();

        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_ENDPOINT}/media-education/get-data?title=${name}`
            );

            if (response.data && response.data.data) {
                setData(response.data.data);
                return response.data.data;  
            }
        } catch (error) {
            navigate("/404");
            console.log(error);
        }
        return navigate("/404");;
    };

    const updateViewCount = async (id: string) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_ENDPOINT}/media-education/update-view/${id}`,
            );
        } catch (error) {
            console.log("Gagal update view count:", error);
        }
    };

    const handleCopyLink = () => {
        const linkToCopy = `${window.location.origin}${window.location.pathname}`;
        navigator.clipboard.writeText(linkToCopy)
            .then(() => alert("URL berhasil disalin!"))
            .catch((error) => console.error("Gagal menyalin URL:", error));
    };

    useEffect(() => {
        (async () => {
            const fetchedData = await getData();
            if (fetchedData && fetchedData.id) {
                await updateViewCount(fetchedData.id);
            }
        })();
    }, []);

    if (data === null) {
        return <div className="text-center mt-28">Loading...</div>;
    }

    const videoUrl = `${process.env.REACT_APP_API_ENDPOINT}/media-education/getfile/${data.video_education}`;

    return (
        <div className="max-w-screen-2xl mx-auto pt-16 pb-1 p-4 md:p-5 lg:px-16">
            <div className="flex justify-center mt-8 mb-8">
                {data.video_education ? (
                    <VideoPlayer url={videoUrl} />
                ) : (
                    <div className="text-center">Video tidak tersedia</div>
                )}
            </div>

            <h1
                className="text-bprYellow font-poppinsBold text-2xl mb-4 text-center md:text-left"
                dangerouslySetInnerHTML={{
                    __html: data.title?.toUpperCase() || "",
                }}
            />

            <div className="flex flex-wrap items-center justify-between gap-3 border-b border-gray-200 pb-4 text-sm text-bprDarkBlue">
                <div className="flex gap-4 flex-wrap">
                    <span className="font-poppinsRegular">
                        Oleh <strong>Admin</strong>
                    </span>
                    <span className="font-poppinsRegular">
                        {new Intl.DateTimeFormat("id-ID", {
                            day: "numeric",
                            month: "long",
                            year: "numeric",
                        }).format(new Date(data.created_at))}
                    </span>
                    <span className="font-poppinsRegular">
                        Durasi: {data.duration}
                    </span>
                </div>
                <div className="flex gap-3 items-center">
                    <FaEye className="text-base" />
                    <span>{data.format_view} dilihat</span>
                    <IoMdShare
                        className="text-xl cursor-pointer hover:text-blue-500"
                        title="Bagikan"
                        onClick={handleCopyLink}
                    />
                </div>
            </div>

            <div className="mt-8 mb-16">
                <article className="prose max-w-none text-[#627D92] font-poppinsRegular text-base">
                    <div
                        dangerouslySetInnerHTML={{
                            __html: data.description ?? "Deskripsi belum tersedia.",
                        }}
                    />
                </article>
            </div>
        </div>
    );
}
